(function() {
  'use strict';

  // ── Image Gallery ──
  window.switchImage = function(thumbEl) {
    var url = thumbEl.getAttribute('data-image-url');
    var mainImg = document.getElementById('mainImage');
    if (mainImg && url) {
      mainImg.style.opacity = '0';
      setTimeout(function() {
        mainImg.src = url;
        mainImg.onload = function() { mainImg.style.opacity = '1'; };
      }, 150);
    }
    document.querySelectorAll('.gallery-thumb').forEach(function(t) {
      t.classList.remove('active');
    });
    thumbEl.classList.add('active');
  };

  // ── Variant / Size Selector ──
  window.selectVariant = function(el) {
    var variantId = el.getAttribute('data-variant-id');
    var price = el.getAttribute('data-variant-price');
    
    document.querySelectorAll('.size-btn').forEach(function(b) {
      b.classList.remove('active');
    });
    el.classList.add('active');
    
    var idField = document.getElementById('variantId');
    if (idField) idField.value = variantId;
    
    if (price) {
      var priceEl = document.getElementById('productPrice');
      if (priceEl) priceEl.textContent = price;
      var btn = document.getElementById('addToCartBtn');
      if (btn) {
        var ctaText = btn.getAttribute('data-cta-text') || 'Claim Yours';
        btn.textContent = ctaText + ' — ' + price;
      }
    }
  };

  // ── Quantity ──
  var qty = 1;
  window.changeQty = function(delta) {
    qty = Math.max(1, Math.min(5, qty + delta));
    var display = document.getElementById('qtyVal');
    var input = document.getElementById('qtyInput');
    if (display) display.textContent = qty;
    if (input) input.value = qty;
  };

  // ── AJAX Add to Cart ──
  var form = document.getElementById('addToCartForm');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = document.getElementById('addToCartBtn');
      if (!btn) return;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(document.getElementById('variantId').value),
          quantity: parseInt(document.getElementById('qtyInput').value)
        })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '✓ Added to Bag';
        btn.style.background = '#1a7a3a';
        
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var counter = document.getElementById('cartCount');
            if (counter) counter.textContent = cart.item_count;
          });
        
        setTimeout(function() {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      })
      .catch(function() {
        btn.textContent = 'Error — Try Again';
        btn.style.background = '#991b1b';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2500);
      });
    });
  }

  // ── Accordion ──
  window.toggleAccordion = function(trigger) {
    var item = trigger.parentElement;
    var panel = item.querySelector('.accordion-panel');
    var isOpen = item.classList.contains('open');
    
    document.querySelectorAll('.accordion-item').forEach(function(i) {
      i.classList.remove('open');
      var p = i.querySelector('.accordion-panel');
      if (p) p.style.maxHeight = '0';
    });
    
    if (!isOpen) {
      item.classList.add('open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  };

  // ── Wishlist Toggle ──
  window.toggleWishlist = function(el) {
    if (el.innerHTML.indexOf('♡') > -1) {
      el.innerHTML = '♥&ensp;Added to Wishlist';
      el.style.borderColor = 'var(--red)';
      el.style.color = 'var(--red)';
    } else {
      el.innerHTML = '♡&ensp;Add to Wishlist';
      el.style.borderColor = '';
      el.style.color = '';
    }
  };

  // ── Scroll Reveal ──
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.12 });
    
    document.querySelectorAll('.fade-up').forEach(function(el) {
      observer.observe(el);
    });
  }

  // ── Sticky CTA ──
  var stickyCta = document.getElementById('stickyCta');
  if (stickyCta) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 800) {
        stickyCta.classList.add('show');
      } else {
        stickyCta.classList.remove('show');
      }
    }, { passive: true });
  }

})();
